import React from 'react';
import { SmartphoneIcon, TabletIcon, MonitorIcon } from 'lucide-react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function FormatsSection() {
  return <section className="w-full py-20 bg-white" data-id="element-134">
      <div className="max-w-4xl mx-auto px-6" data-id="element-135">
        <div className="text-center mb-12" data-id="element-136">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-6" data-id="element-137">
            Acceso Digital Inmediato
          </h2>
          <p className="text-xl text-gray-600" data-id="element-138">
            Lee en tu celular, tablet o computadora. Descárgalo y consérvalo
            para siempre.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-139">
          <div className="text-center p-6" data-id="element-140">
            <div className="inline-block p-4 bg-emerald-100 rounded-full mb-4" data-id="element-141">
              <SmartphoneIcon className="w-12 h-12 text-emerald-600" data-id="element-142" />
            </div>
            <h3 className="font-bold text-lg text-navy-900 mb-2" data-id="element-143">
              iPhone & Android
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-144">
              Lee en tu celular en cualquier momento
            </p>
          </div>

          <div className="text-center p-6" data-id="element-145">
            <div className="inline-block p-4 bg-cyan-100 rounded-full mb-4" data-id="element-146">
              <TabletIcon className="w-12 h-12 text-cyan-600" data-id="element-147" />
            </div>
            <h3 className="font-bold text-lg text-navy-900 mb-2" data-id="element-148">
              iPad & Tablets
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-149">
              Experiencia de lectura cómoda
            </p>
          </div>

          <div className="text-center p-6" data-id="element-150">
            <div className="inline-block p-4 bg-teal-100 rounded-full mb-4" data-id="element-151">
              <MonitorIcon className="w-12 h-12 text-teal-600" data-id="element-152" />
            </div>
            <h3 className="font-bold text-lg text-navy-900 mb-2" data-id="element-153">
              Computadora
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-154">Lee en pantalla grande</p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 rounded-3xl p-8 text-center" data-id="element-155">
          <div className="space-y-4 mb-6" data-id="element-156">
            <p className="flex items-center justify-center gap-2 text-gray-700" data-id="element-157">
              <span className="text-emerald-500" data-id="element-158">✔</span>
              Compatible con iPhone, Android, iPad y computadora
            </p>
            <p className="flex items-center justify-center gap-2 text-gray-700" data-id="element-159">
              <span className="text-emerald-500" data-id="element-160">✔</span>
              Optimizado para lectura fácil
            </p>
          </div>

          <Button size="lg" href={CHECKOUT_URL} data-id="element-161">
            👉 Quiero controlar mi dinero desde hoy
          </Button>
          <p className="text-sm text-gray-500 mt-4" data-id="element-162">
            Compra 100% segura • Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}